import * as React from "react";

export const SvgHamburgerMenu = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M18.25 11.25H1.75a.75.75 0 0 1 0-1.5h16.5a.75.75 0 0 1 0 1.5ZM18.25 5.5H1.75a.75.75 0 0 1 0-1.5h16.5a.75.75 0 0 1 0 1.5ZM18.25 17H1.75a.75.75 0 0 1 0-1.5h16.5a.75.75 0 0 1 0 1.5Z"
			fill={props.color ?? "#A8A8A8"}
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={0.4}
		/>
	</svg>
);
